'use client';
var IDENT = "Divider";
var defaultProps = {
    orientation: "horizontal",
    size: "xs1",
    variant: "solid",
    align: "start"
};

export { IDENT, defaultProps };
